// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/information-circle.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/information-circle'

import { Icon, type IconComponentProps } from '../icon'

export const InformationCircleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
